import React, { Component, Fragment } from 'react';
import './sharePopup.scss'
import Modal from 'react-bootstrap/Modal'
import axios from 'axios';
import copy from 'copy-to-clipboard';
import Snackbar from '@mui/material/Snackbar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectAll, checkOne } from '../../ActionCreators/shareAction';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';

// THIS CAN USED FOR SOCIAL SHARE 
class SharePopup extends Component {
    state = {
        emails: [], emailsCopy: [],
        shareUrl: '',
        errorMessage: false,
        errorEmailMessage: false,
        errorEmail: '',
        succesEnable: false,
        checkedId: []
    }


    selectedEmail = (items) => {
        if (!this.state.emailsCopy.includes(items._id)) {
            this.setState({
                emailsCopy: [...this.state.emailsCopy, items._id],
                emails: [...this.state.emails, items],
                errorEmailMessage: false,
                errorEmail: '',
                emailsuggestion: ''
            })
            $('.email-suggestion').hide();
            $('#email1').val('').focus();
        }
        else {
            console.log('email is already present')
        }
    }

    componentWillUnmount = () => {
        this.timer = null;
    };


    selectUser = (val) => {
        clearTimeout(this.timer);
        this.setState({
            emailsuggestion: val,
            suggestion: []
        },
            async () => {
                this.timer = setTimeout(this.getSearch, 500);
            }
        );
    }

    getSearch = () => {
        let AuthStr = 'Bearer ' + localStorage.getItem("loginToken");
        axios.get(process.env.REACT_APP_API_KEY + 'helper/users/' + this.state.emailsuggestion, { headers: { Authorization: AuthStr } }).then((result) => {
            if (result.data.success) {
                this.setState({
                    suggestion: result.data.data,
                })
            }
        })
    }


    handleDelete = (id, i) => {
        var mails = this.state.emails.filter((chip) => chip._id !== id)
        var mailsCopy = this.state.emailsCopy.filter((chip) => console.log("1183", chip))
        this.setState({
            emails: mails,
            emailsCopy: mailsCopy
        })

    };

    getShareUrl = (type, id, sharesite) => {
        let resource = {
            resource_id: id,
            resource_type: type
        }
        let AuthStr = 'Bearer ' + localStorage.getItem("loginToken");
        axios.post(process.env.REACT_APP_API_KEY + 'user/share/resource/external', resource, { headers: { Authorization: AuthStr } }).then((result) => {
            if (result.data.success) {
                this.setState({
                    shareUrl: result.data.url,

                }, () => {
                    switch (sharesite) {
                        case 'facebook':
                            if (navigator.userAgent.match(/iPhone|Android/i)) {
                                if (/iP(ad|od|hone)/i.test(window.navigator.userAgent) && /WebKit/i.test(window.navigator.userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent))) {

                                    window.location.href = `https://www.facebook.com/dialog/share?app_id= 1675249859222150&display=popup&href=${encodeURIComponent(this.state.shareUrl)}`
                                }
                                else {
                                    window.open(`https://www.facebook.com/dialog/share?app_id=1675249859222150&display=popup&href=${encodeURIComponent(this.state.shareUrl)}`)
                                }
                            }
                            else {
                                // var winTop = (screen.height / 2) - (600 / 2);
                                // var winLeft = (screen.width / 2) - (600 / 2);
                                window.open(`http://www.facebook.com/sharer/sharer.php?s=100&p[title]=${this.props.shareObj?.title}&p[url]=${this.state.shareUrl}&p[images][0]=${this.props.shareObj?.image},sharer,toolbar=0,status=0,width=600px,height=600px`)
                            }
                            break
                        case 'twitter':
                            if (/iP(ad|od|hone)/i.test(window.navigator.userAgent) && /WebKit/i.test(window.navigator.userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent))) {
                                window.location.href = `http://twitter.com/share?url=${this.state.shareUrl}&text=${this.props.shareObj?.title},sharer,toolbar=0,status=0,width=626,height=436`
                            }
                            else {

                                window.open(`http://twitter.com/share?url=${this.state.shareUrl}&text=${this.props.shareObj?.title},sharer,toolbar=0,status=0,width=626,height=436`)
                            }
                            break
                        case 'linkedin':
                            if (/iP(ad|od|hone)/i.test(window.navigator.userAgent) && /WebKit/i.test(window.navigator.userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent))) {
                                window.location.href = `http://www.linkedin.com/shareArticle?url=${encodeURIComponent(this.state.shareUrl)}&title=${this.props.shareObj?.title},_blank,width=500,height=500,resizable=yes,scrollbars=yes`;
                            }
                            else {

                                window.open(`http://www.linkedin.com/shareArticle?url=${encodeURIComponent(this.state.shareUrl)}&title=${this.props.shareObj?.title},_blank,width=500,height=500,resizable=yes,scrollbars=yes`)
                            }
                            break
                        // https://www.linkedin.com/sharing/share-offsite/?url=http%3A%2F%2Ftinyurl.com%2Fy39m2mou
                        // https://www.linkedin.com/shareArticle/?url=http%3A%2F%2Ftinyurl.com%2Fyxcn4pc4&title=Big%20Data%20Analytics(edX)
                        case 'whatsapp':
                            if (navigator.userAgent.match(/iPhone|Android/i)) {
                                if (/iP(ad|od|hone)/i.test(window.navigator.userAgent) && /WebKit/i.test(window.navigator.userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent))) {
                                    window.location.href = `https://api.whatsapp.com/send?text=${this.state.shareUrl},toolbar=0,status=0,width=626,height=436`;
                                } else {

                                    window.open(`https://api.whatsapp.com/send?text=${this.state.shareUrl},toolbar=0,status=0,width=626,height=436`)
                                }
                            }
                            else {
                                window.open(`https://web.whatsapp.com/send?l=en&text=${this.state.shareUrl}`)
                            }
                            break
                        default:
                            copy(this.state.shareUrl)
                            break
                    }
                })



            }
        })
    }

    shareToAll = async (type, id, shareval) => {
        if (!this.state.emails.length) {
            this.setState({
                errorEmailMessage: true,
                errorEmail: 'Please select email address'
            })
        } else {
            let resource = {
                all: false,
                to: this.state.emails.map(el => el._id),
                resource_type: type,
                resource_id: id,
                my_content: window.location.pathname === '/my-content' ? true : false
            }
            await this.props.shareAll(resource);
            await this.props.shareModalClose();
            this.setState({
                emails: [],
                errorEmailMessage: false,
                errorEmail: '',
                sharevalue: '',
                emailsCopy: [],
                suggestion: [],
                showSpecific: false,
                succesEnable: true,
                isButtonDisabled: false
            });
        }
        // else {
        //     let resource = {
        //         all: true,
        //         resource_type: type,
        //         resource_id: id

        //     }
        //     this.setState({
        //         isButtonDisabled: true
        //     })
        //     await this.props.shareAll(resource);
        //     await this.props.shareModalClose();
        //     this.setState({
        //         emails: [],
        //         errorEmailMessage: false,
        //         errorEmail: '',
        //         sharevalue: '',
        //         emailsCopy: [],
        //         suggestion: [],
        //         showSpecific: false,
        //         succesEnable: true,
        //     });
        // }
    }


    resetModal = async () => {
        await this.props.shareModalClose();
        this.setState({
            checkedId: [],
            emails: []
        })
    }
    snackClosed() {
        this.setState({
            successMessage: false,
            succesEnable: false,
            successMessageText: ""
        })
    }

    checkAll = async (e) => {
        this.setState({
            checked: e.target.checked
        })
        await this.props.selectAll(e.target.checked)
        const list = this.props.userList.filter(el => el.isChecked === true);
        this.setState({
            checkedId: list
        })
    }

    selectOne = async (e, el) => {
        await this.props.checkOne(e.target.value, e.target.checked)
        if (e.target.checked) {
            this.setState({
                checkedId: [...this.state.checkedId, el]
            })
        }
        else {
            this.setState({
                checkedId: this.state.checkedId.filter(el => el.email !== e.target.value)
            })
        }
    }
    render() {
        const { shareObj, isShareFeedPopup, t, theme, successEnable, successMessageText } = this.props
        return (
            <Fragment>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={this.state.successMessage}
                    onClose={() => this.snackClosed()}
                    message={this.state.successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.props.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />

                {
                    shareObj !== undefined &&
                    <Modal show={isShareFeedPopup} style={{ backdropFilter: 'none' }} centered aria-labelledby="contained-modal-title-vcenter" dialogClassName={"share-modal"}>
                        <Modal.Body style={{ padding: '22px 27px' }}>
                            <button type="button" className="close" onClick={() => this.resetModal()} data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><img src='/images/close.svg' alt='' /></span>
                            </button>
                            <div className='share-pod-details'>
                                <div className='position-relative' >
                                    <img src={shareObj?.image} className="rounded " width="90px" height="64px" onError={(e) => {
                                        if (e.target.src !== "/images/empty-image.png") {
                                            e.target.onerror = "/images/empty-image.png";
                                            e.target.src = "/images/empty-image.png";
                                        }
                                    }} alt='' />
                                    <span><img src='/images/share-round.svg' alt='' /></span>
                                </div>
                                <div className='pod-details'>
                                    <p>{shareObj?.type === 'Bubble' ? t('Share Skill Pod') : shareObj?.type === 'Skillpath' ? t('Share Skill Path') : `${t('Share')} ${t(shareObj?.type)}`}</p>
                                    <small className='elipsis'>{shareObj?.title}</small>
                                </div>
                            </div>
                            <div className='search-user'>
                                <p>{t('Share with People')} </p>
                                <div className='position-relative'>
                                    <div className="col-sm-12 form-control email-id-row">
                                        <span className="to-input"><img src='/images/search.svg' alt='' /></span>
                                        <div className="all-mail" >
                                            <input autoFocus type="text" id="email1" autoComplete="off" value={this.state.emailsuggestion} name="email" placeholder="Search by name .." onChange={(e) => this.selectUser(e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="all-mail" >
                                        {
                                            this.state.emails.length > 0 ?
                                                this.state.emails.map((email, i) => {
                                                    return (
                                                        <div style={{ paddingRight: 10 }}>
                                                            <Chip
                                                                size="small"
                                                                avatar={<Avatar src={email.profile_image} />}
                                                                label={email.name}
                                                                onDelete={() => this.handleDelete(email._id, i)}
                                                            />
                                                        </div>
                                                    )
                                                })
                                                : null
                                        }
                                    </div>
                                    {this.state.suggestion !== undefined && this.state.suggestion.length > 0 && this.state.emailsuggestion !== "" ?
                                        <div className="email-suggestion" >
                                            <ul>
                                                {
                                                    this.state.suggestion !== undefined && this.state.suggestion.length > 0 ?
                                                        this.state.suggestion.map((items, i) => {

                                                            return (

                                                                <li onClick={() => this.selectedEmail(items)}>
                                                                    <div className="container-fluid">
                                                                        <div className="row">
                                                                            <div className="col-md-2 intial " style={{ background: `${items.color}`, color: '#fff' }}>
                                                                                {items.profile_image !== null && items.profile_image !== '' ? <img className="rounded-circle" src={items.profile_image} width="37px" height="37px" alt='' /> : items.initial}
                                                                            </div>
                                                                            <div className="col-md-10 email-tag text-capitalize">
                                                                                {items.name}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            )
                                                        }) : null
                                                }
                                            </ul>
                                        </div> : null
                                    }
                                    {
                                        this.state.errorEmailMessage ? <div style={{ color: 'red', fontSize: 12 }}>{this.state.errorEmail}</div> : null
                                    }
                                </div>
                            </div>
                            <div className='share-btn'>
                                <button style={{ backgroundColor: theme.bgColor }} className='button-color' onClick={() => { this.shareToAll(shareObj?.type, shareObj?._id, this.state.sharevalue) }}>{t('Share')}</button>&nbsp;&nbsp;
                                <button onClick={this.resetModal}>{t('cancel')}</button>
                            </div>
                            <div className='social-logins'>
                                <div style={{ width: window.innerWidth > 767 ? '40%' : '50%' }}>
                                    Share on social media
                                </div>
                                <div className='social-icon' style={{ width: '60%' }}>
                                    <div style={{ background: '#1580CE' }} onClick={() => this.getShareUrl(shareObj?.type, shareObj?._id, 'facebook')} className="icon">
                                        <img src='/images/facebook.svg' alt='' />
                                    </div>
                                    <div style={{ background: '#50ABF1' }} onClick={() => this.getShareUrl(shareObj?.type, shareObj?._id, 'linkedin')} className="icon" >
                                        <img src='/images/linkedin.svg' alt='' />
                                    </div>
                                    <div style={{ background: '#0085A5' }} onClick={() => this.getShareUrl(shareObj?.type, shareObj?._id, 'twitter')} className="icon">

                                        <img src='/images/twitter.svg' alt='' />
                                    </div>
                                    <div style={{ background: '#00E676' }} onClick={() => this.getShareUrl(shareObj?.type, shareObj?._id, 'whatsapp')} className="icon">
                                        <img src='/images/whatsapp.svg' alt='' />
                                    </div>
                                    <div style={{ background: '#8B7DF2' }} onClick={() => this.getShareUrl(shareObj?.type, shareObj?._id)} className="icon">
                                        <img src='/images/copylink.svg' alt='' />
                                    </div>
                                </div>
                            </div>

                            {/* <div className='user-lists'>
                                <h2>Select users from list</h2>
                                <div className='select-student'>
                                    <div className="row-header">
                                        <p> <input type='checkbox' style={{ width: 16, height: 16, verticalAlign: 'middle' }} checked={this.state.checked}
                                            onChange={(e) => this.checkAll(e)}
                                        /> &nbsp;Select all users</p>
                                        <div className="student-tab">
                                        </div>
                                    </div>
                                    <ul className='student-list'>{
                                        userList !== undefined && userList.map((el, index) => {
                                            return (
                                                <li key={index}>
                                                    <input type='checkbox' style={{ width: 16, height: 16, verticalAlign: 'middle' }}
                                                        onChange={(e) => this.selectOne(e, el)}
                                                        value={el.email} checked={el.isChecked} /> &nbsp;{el.name}
                                                </li>
                                            )
                                        })
                                    }
                                    </ul>
                                </div>
                            </div> */}
                        </Modal.Body>

                    </Modal>
                }
            </Fragment>
        )
    }
}

const mapStatetoProp = (state) => {
    const { userList } = state.share
    const { theme } = state.account
    return {
        userList, theme
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ selectAll, checkOne }, dispatch)
}
export default withTranslation('common')(connect(mapStatetoProp, mapDispatchToProps)(SharePopup));